//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  import common from "../../api/common";
  export default {
    data() {
      return {
        message:'',
        loading1:'',
        manyi:'0',
        bumanyi:'0',
        yiban:'0',
        docid: "",
        item: {},
        datalist: "",
        skillname: [],
        arguedis:[],
        counts: "",
        isbuy: 0,
        istrue: 0,
        pinglun:{},
        cities : ["能力强","负责任","有问必答","不予理睬","不满意","服务态度好"],
        judgeInfo:'',
        arr : [],
        arr1 : [],
      };
    },
    methods: {
      query() {
      this.getNumber();
          let data = {
            pageLength:999,
            "doctorId":this.$route.query.id,
            condition: {
              status:2,
              "doctorId":this.$route.query.id,
               commentlabel:this.message,
              "patientId":this.$store.state.userInfo.id,
              "patientendFlag":1
            }
          };
          let _this = this;
          this.$doRequest('/api/judge/getjudgelistPage', data, res=>{
            for(let i=0;i<res.parameters.rows.length;i++){
              res.parameters.rows[i].telephone= "" + res.parameters.rows[i].telephone;
              let ary = res.parameters.rows[i].telephone.split("");
              ary.splice(3,7,"*******");
              res.parameters.rows[i].telephone=ary.join("");
              if(res.parameters.rows[i].commentlabel!=''){
                res.parameters.rows[i].commentlabel=  res.parameters.rows[i].commentlabel.split(',');
              }
            }
            _this.pinglun=res.parameters.rows;
          })
        },
      getNumber(){
        let data = {
          parameters: this.$route.query.id,
        };
        let _this = this;
        this.$doRequest('/api/judge/getDoctorJudgeStatistics', data, res=>{
          this.manyi=res.parameters.good;
          this.yiban=res.parameters.normal;
          this.bumanyi=res.parameters.bad;
          this.cities=res.parameters.commentResults;
        })
      },
      checkedBox(i) {
//        if (this.arr.includes(i)) {
          if (this.arr.indexOf(i) != -1) {
            //includes()方法判断是否包含某一元素,返回true或false表示是否包含元素，对NaN一样有效
            //filter()方法用于把Array的某些元素过滤掉，filter()把传入的函数依次作用于每个元素，然后根据返回值是true还是false决定保留还是丢弃该元素：生成新的数组
//          this.arr = this.arr.filter(function (ele) {
//            return ele != i;
//          });

            this.arr.splice(this.arr.indexOf(i), 1);
            this.message='';
            this.query();
          } else {
            if(this.arr.length>0){
              this.arr.splice(0,1);
            }
            this.arr.push(i);
//            console.log(this.arr)
            this.message = i;
            this.query();
          }

//        }
      },
//      getBiaoqian(){
//        this.$doRequest("/api/judge/getJudgeCommentlabel", {}, res=>{
//          this.cities=res.parameters;
//        })
//      },
      gotoinfo() {
        if(this.datalist.isOrder!=0){
          this.$router.push({ path: "/buyServiceDetails" });
        }
      },
      routerToNotice(){
        this.$router.push({ path: '/notice',query: {id: this.docid}});
      },
      routerToNoticeDetails(datas){
        this.$router.push({ path: '/noticeDetails',query: {data: datas}})
      },
      xiangqing(item,index){
        if(this.loading1!=index){
          this.loading1=index;
        }else{
          this.loading1=-1
        }

        console.log(index);
      },
    },
    //生命周期之挂载完成
    mounted: function() {

    },
    //生命周期之创建完成
    created: function() {
      document.title = '所有评价';
      if(!this.$store.state.userInfo.sessionId){
        this.$store.state.userInfo.sessionId = 'haozhongyi';
      }
      this.query();
      // this.getNumber();
//      this.$isLogin(window.location.search.substr(1), this.query);
    },
    //生命周期之更新
    updated: function() {},
    //生命周期之销毁
    destroyed: function() {},
    watch: {
      istrue: function(value, newvalue) {
        this.istrue = value;
      }
    }
  };



// WEBPACK FOOTER //
// ./src/views/allBudject/index.vue